import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json';
import ptTranslation from './locales/pt.json';

/**
 * Idioma utilizado pelo site, se estiver utilizando para testar um idioma ou 
 * outro, sobrescreva essa variável para o idioma desejado. 
 * 
 * **OBS**: Esse arquivo não deve ser atualizado em caso de testes, cuidado ao 
 * realizar o commit!
 */
const browserLanguage: string = navigator?.language?.slice(0, 2) ?? 'pt';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
    },
    lng: browserLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;